import { HelpCenter } from "@mui/icons-material";
import { ThemeProvider, createTheme } from "@mui/material";
import MobileView from "components/wrapper_v2/MobileView";
import { COLOR_CONSTANTS } from "config/helpers/color_helper";
import { exceptionalRoutes } from "config/helpers/common_helper";
import { getPathNames } from "config/helpers/router_helper_v2";
import useIsEnterpriseOrg from "hooks/useIsEnterpriseOrg";
import { isEqual } from "lodash";
import MobileWrapper from "mobile/mobileComponents/mobileWrapper";
import React, { useEffect, useMemo } from "react";
import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";

// const Wrapper = React.lazy(() => import("components/wrapper/Wrapper"));

export const AuthRoute = ({ component: Component }) => {
  const location = useLocation();
  const auth = useSelector((state) => state.auth, isEqual);
  const app = useSelector((state) => state.app, isEqual);
  const pathName = getPathNames()?.[1];
  const themeLight = useMemo(() => {
    document.documentElement.setAttribute("data-bs-theme", app.theme);
    return createTheme({
      palette: {
        mode: app.theme,
        ...(app.theme === "dark"
          ? {
            textFieldColor: "#387CA3",
            background: {
              default: "#2e3740",
              paper: "#201F48", 
            },
            primary: {
              main: COLOR_CONSTANTS.PRIMARY,
            },
            dataGridHeaderColor: "#00adb5",
          }
          : {
            textFieldColor: "#387CA3",
            primary: {
              main: COLOR_CONSTANTS.PRIMARY,
            },
            dataGridHeaderColor: "#f8f8f8",
          }),
      },
      zIndex: {},
      typography: {
        fontFamily: `"Poppins", sans-serif`,
      },
    });
  }, [app.theme]);

  const muiTheme = createTheme({
    typography: {
      // fontFamily: `"Poppins", sans-serif`,
      fontFamily: `"Poppins", sans-serif !important`,
    },
  });
  return !auth.isUserLoggedIn ? (
    <>
      <React.Suspense>
        <ThemeProvider theme={muiTheme}>
          <div
            className="noki-wrapper-message"
            style={{ display: exceptionalRoutes?.includes(pathName) && "none" }}
          >
            <MobileView />
          </div>
          <div className="noki-wrapper" style={{ display: exceptionalRoutes?.includes(pathName) && 'block' }}>
            <Component />
          </div>
        </ThemeProvider>
      </React.Suspense>
    </>
  ) : (
    <Navigate
      to={{ pathname: "/home/dashboard" }}
      replace
      state={{ from: location }}
    />
  );
};

export const OpenRoute = ({ component: Component }) => {
  return (
    <>
      <React.Suspense>
        <Component />
      </React.Suspense>
    </>
  );
};

export const DashboardRoute = ({ component: Component }) => {
  const inProgress = useSelector((state) => state.isLoading.progress);
  const encounterLoading = useSelector(state => state?.isLoading?.encLoading)
  const auth = useSelector((state) => state.auth, isEqual);
  const location = useLocation();
  const userRoles = useSelector((state) => state?.auth?.userRoles);
  const isAdmin = userRoles?.some((r) => r.code === "admin" && r.is_active);
  const isEnterpriseOrg = useIsEnterpriseOrg();

  // Mirrors desktop's admin restriction (containers/routes/RouterHelpers.jsx)
  // - an org admin only manages users/billing, not clinical work, so every
  // other page redirects rather than rendering, including via direct URL
  // navigation. /manager (Users/Permissions/Nurse Mapping/Billing) is the
  // equivalent landing page; /settings stays allowed too (mobile's Settings
  // page can't be split into a narrower "profile-only" exception the way
  // desktop's can); Store stays allowed for enterprise orgs specifically, to
  // view/renew the org's plan.
  if (
    auth.isUserLoggedIn &&
    isAdmin &&
    !location.pathname.startsWith("/manager") &&
    !location.pathname.startsWith("/settings") &&
    !(isEnterpriseOrg && location.pathname.startsWith("/store"))
  ) {
    return <Navigate replace to={{ pathname: "/manager/users" }} />;
  }

  return auth.isUserLoggedIn ? (
    <div
      style={{
        cursor: (inProgress || encounterLoading) ? "progress" : "auto",
      }}
    >
      <div
        style={{
          pointerEvents: (inProgress || encounterLoading) ? "none" : "all",
        }}
      >
        <MobileWrapper>
          <>{Component}</>
        </MobileWrapper>
      </div>
    </div>
  ) : (
    <Navigate replace to={{ pathname: "/" }} />
  );
};
